import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'joinList'
})
export class JoinListPipe implements PipeTransform {

  transform(value: unknown, displayCount: number): string {
    if (!_.isNil(displayCount)) {
      const items = Object.values(value).slice(0, displayCount).map(x => x.Name).join(', ');
      const itemsLength = Object.values(value).length;
      return itemsLength > 2 ? `${items}, +${itemsLength - displayCount} autres groupes` : items;
    }
    return Object.values(value).map(x => x.Name).join(', ');
  }
}
